(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable',
      'pikaday'
    );

  angular.module('MktzapApp.Controllers')
    .controller('NumbersController', numbers);

  numbers.$inject = ['$scope', 'ngTableParams', '$http', 'FoundationApi'];

  function numbers ($scope, ngTableParams, $http, FoundationApi) {
    var vm = this;

    vm.companies = []; // Displays the company options
    vm.modal = {}; // Configures the modal actions and title
    vm.number = {}; // Holds the both creating and editting object
    vm.due_date = null;

    vm.channelsTable = new ngTableParams({
      page: 1, // show first page
      count: 300 // count per page
    }, {
      getData: function ($defer, params) {
        $http.get(apiUrl + '/channels/paged', {
          params: params.url()
        })
          .then(function ({ data, status, headers, config }) {
            params.total(data.total);
            $defer.resolve(data.data);
          }, function (error) { console.log(error) });
      }
    });

    vm.modalForm = function () {
      vm.number = {};
      vm.modal.mode = 'create';
      vm.modal.title = $scope.labels.newNumber;

      vm.due_date.setDate(null);

      FoundationApi.publish('numbersForm', 'open');
    };

    vm.createNumber = function () {
      vm.number.due_date = moment(vm.due_date.getDate()).format('YYYY-MM-DD');

      $http.post(apiUrl + '/channels', vm.number)
        .then(function (response) {
          vm.channelsTable.reload();
        }, function (error) { console.log(error) })
    };

    vm.editNumber = function (numberId) {
      vm.due_date.setDate(null);

      $http.get(apiUrl + '/channels/' + numberId)
        .then(function ({ data }) {
          vm.number = data;
          vm.due_date.setDate(data.due_date);

          vm.modal.mode = 'edit';
          vm.modal.title = $scope.labels.editNumber;

          FoundationApi.publish('numbersForm', 'open');
        }, function (error) { console.log(error) });
    };

    vm.saveNumber = function () {
      vm.number.due_date = moment(vm.due_date.getDate()).format('YYYY-MM-DD');

      $http.patch(apiUrl + '/channels/' + vm.number.id, vm.number)
        .then(function () {
          vm.channelsTable.reload();
        }, function (error) { console.log(error) });
    };

    $http.get(apiUrl + '/companies')
      .then(function ({ data }) {
        vm.companies = data;
      }, function (error) { console.log(error) });
  }
})();
